import { render, staticRenderFns } from "./AddReportCustomGroup.vue?vue&type=template&id=7ca5c3be"
import script from "./AddReportCustomGroup.vue?vue&type=script&lang=js"
export * from "./AddReportCustomGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports